/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_APPLICATION_DETAILS_AGE_RATING_REQUEST,
  FETCH_APPLICATION_DETAILS_AGE_RATING_SUCCESS,
  FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE,
} from "./ApplicationDetailsAgeRatingTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchApplicationAgeRatingRequest = () => {
  return {
    type: FETCH_APPLICATION_DETAILS_AGE_RATING_REQUEST,
  };
};

export const fetchApplicationAgeRatingSuccess = (ageRatingData) => {
  return {
    type: FETCH_APPLICATION_DETAILS_AGE_RATING_SUCCESS,
    payload: ageRatingData,
  };
};

export const fetchApplicationAgeRatingFailure = (error) => {
  return {
    type: FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE,
    payload: error,
  };
};

export const fetchApplicationDetailsAgeRating = () => {
  return async function (dispatch) {
    dispatch(fetchApplicationAgeRatingRequest());
    try {
      const data = await APIManager.getAgeRatings();
      dispatch(fetchApplicationAgeRatingSuccess(data));
    } catch (error) {
      console.error("error====>", error);
      dispatch(fetchApplicationAgeRatingFailure(error));
      dispatch(
        commonError(error, FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE)
      );
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
